// removed by extract-text-webpack-plugin
module.exports = {"tag":"index__tag___2Q7co","disabled":"index__disabled___25-TF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/Tags/index.less
// module id = 1235
// module chunks = 3